import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"

const RefreshPageFallback = () => {
  const { t } = useTranslation()

  return (
    <div className="h-screen w-screen overflow-hidden">
      <main className="bg-background-subdued flex h-full flex-col items-center justify-center gap-4">
        <h1 className="text-on-surface text-xl">{t("error.refreshTitle")}</h1>
        <Button variant="secondary" onClick={() => window.location.reload()}>
          {t("error.refreshPage")}
        </Button>
      </main>
    </div>
  )
}

export { RefreshPageFallback }
